import DocumentToolNav from '@/components/DocumentToolNav';
import { Outlet, useLocation } from 'react-router-dom';
import TopNav from './TopNav';
import Breadcrumb from './Breadcrumb';
import { isDesktop } from '@/lib/platform';
import DesktopShell from './desktop/DesktopShell';

const NO_BREADCRUMB_PATHS = ['/tools', '/account', '/cloud', '/esign', '/help', '/contact'];

export default function TopNavLayout() {
  // Hooks must run before any early return (rules-of-hooks); harmless on the
  // desktop path where the values go unused.
  const location = useLocation();
  const showBreadcrumb = !NO_BREADCRUMB_PATHS.some((p) => location.pathname.startsWith(p));

  // On desktop the shell owns the full layout (sidebar + header + outlet).
  if (isDesktop()) return <DesktopShell />;

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <TopNav />
      <DocumentToolNav />
      {showBreadcrumb && <Breadcrumb />}
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
